import { useMutation } from "@tanstack/react-query";
import api from "apis";

export function useLoginMutation() {
  return useMutation({ mutationFn: api.auth.postUserLogin });
}

export function useLogoutMutation() {
  return useMutation({ mutationFn: api.auth.postUserLogout });
}

export function useSendTemporaryPassword() {
  return useMutation({ mutationFn: api.user.sendTemporaryPassword });
}

export function useJoinMutation() {
  return useMutation({ mutationFn: api.user.registerUser });
}
